import { ISurveyPlugin } from "../../plugin-host/plugin.interface";

export const browser_fp_plugin : ISurveyPlugin  = {
  id: 'browser-fingerprint',
  name: 'Debug: System Info Collector',
  runOnce: true,
  config: { variable_name: 'debug_metadata' },
  hooks: {
    onPageInit: `
      
      const info = {
        userAgent: navigator.userAgent,
        platform: navigator.platform,
        language: navigator.language,
        screenSize: \`${window.screen.width}x${window.screen.height}\`,
        windowSize: \`${window.innerWidth}x${window.innerHeight}\`,
        devicePixelRatio: window.devicePixelRatio,
        colorDepth: window.screen.colorDepth,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        touchPoints: navigator.maxTouchPoints,
        cookiesEnabled: navigator.cookieEnabled,
        timestamp: new Date().toISOString()
      };

      // Also try to detect the specific browser name
      let browserName = 'unknown';
      if (info.userAgent.indexOf('Firefox') > -1) browserName = 'Firefox';
      else if (info.userAgent.indexOf('SamsungBrowser') > -1) browserName = 'Samsung';
      else if (info.userAgent.indexOf('Opera') > -1 || info.userAgent.indexOf('OPR') > -1) browserName = 'Opera';
      else if (info.userAgent.indexOf('Trident') > -1) browserName = 'IE';
      else if (info.userAgent.indexOf('Edge') > -1) browserName = 'Edge';
      else if (info.userAgent.indexOf('Chrome') > -1) browserName = 'Chrome';
      else if (info.userAgent.indexOf('Safari') > -1) browserName = 'Safari';
      
      info.browserName = browserName;

      // Save as a stringified JSON so it occupies one metadata field
      context.setVariable(context.config.variable_name, JSON.stringify(info));
      console.log('System Debug Info Captured:', info);
    
    `,
    onBeforeSubmit: '// This hook will trigger markPluginAsCompleted',
  },
  version: '',
  configSchema: {},
  variablesSchema: [],
};
